import React from 'react';
import MinionSounds from './MinionSounds';
import HeroSounds from './HeroSounds';
import TokensFlatList from './TokensFlatList'
import SpecialsFlatList from './SpecialsFlatList';
import Specials from './Specials';
import SmallSetImage from './SmallSetImage';
import SoundDivider from './SoundDivider'
import { StyleSheet, Text, View, Image, ScrollView, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import heroes from './assets/heroes.json';
import DeviceContext from './DeviceContext'
import {sortCards, tokenIDs, heroIDs, AVHeroCards, AVHeroPowers, cardVersionGroup, battlegroundFlavor, battlegroundRetired, battlegroundCard, battlegroundTribe} from './HelperFunctions'

const Card = (props) => {

  const scrollViewRef = React.useRef()
  const deviceType = React.useContext(DeviceContext)

  const cardID = props.card.id
  const isHero = heroIDs.includes(cardID)
  const imgSrc = getImage(cardID)

  function getImage(cardID) {

    if (heroIDs.includes(cardID))
      return 'https://hearthstonesounds.s3.amazonaws.com/hero_images/' + cardID + '.png'
    else if (cardID == 'EX1_323h' || (props.battlegrounds && battlegroundTribe(cardID) == 'Bartender') || AVHeroPowers.includes(cardID) || AVHeroCards.includes(cardID))
      return 'https://hearthstonesounds.s3.amazonaws.com/' + cardID + '.png'
    else if (props.battlegrounds)
      return 'https://art.hearthstonejson.com/v1/bgs/latest/enUS/256x/' + cardID + '.png'
    else
      return 'https://art.hearthstonejson.com/v1/render/latest/enUS/256x/' + cardID + '.png'
  }

  function goToTop() {
      scrollViewRef.current.scrollTo({ animated: true, x: 0 })
  }

  function findFlavor() {
    if (isHero)
      return heroes.find(x => x.id == cardID).description
    else if (!props.battlegrounds)
      return props.card.flavor
    else if (props.battlegrounds && battlegroundCard(cardID).heroSpecific)
      return battlegroundFlavor(cardID)
    else if (props.battlegrounds && battlegroundRetired(cardID))
      return 'This card is retired and no longer appears in Battlegrounds.'
  }

  function formatText(text) {

    // Check to see if there are any html tags.
    let regex = new RegExp(/<(?<type>\S+?)>/)
    let valid_tag_types = ['b', 'i', 'color']
    if (text && text.match(regex) != null) {

      let found_opening_tag = text.match(regex)

      let found_tag_type = found_opening_tag.groups.type

      // Handle color tags differently. Store color for later.
      if (found_tag_type.includes('color')) {
        var color = found_tag_type.split("=")[1]
        found_tag_type = 'color'
      }


      // Capture text before the HTML tag.
      let text_before = text.substring(0,found_opening_tag.index)
      
      // Capture text after the opening HTML tag
      let text_leftover = text.substring(found_opening_tag.index + found_opening_tag[0].length)

      // There are some "actions" wrapped in <> - like <sniff> for SW_110. 
      // Don't clip the tag-like string but skip further processing. Continue the recursive chain though.
      if (!valid_tag_types.includes(found_tag_type)) {
        text_before = formatText(text_before) + found_opening_tag[0]
        text_leftover = formatText(text_leftover)
        return [text_before, text_leftover]
      }

      // Find the corresponding closing HTML tag.
      let regex_close = new RegExp("<(\/"+found_tag_type+")>")
      let found_closing_tag = text_leftover.match(regex_close)

      // Build an object that wraps the text between HTML tags.
      let text_mid = text_leftover.substring(0,found_closing_tag.index)

      // Capture text after the closing HTML tag.
      let text_end = text_leftover.substring(found_closing_tag.index + found_closing_tag[0].length)

      // Recursively format test on before, mid, and end.
      text_before = formatText(text_before)
      text_mid = formatText(text_mid)
      text_end = formatText(text_end)

      // Create object wrapped in HTML tags for the middle text.
      if (found_tag_type == 'color') {
        text_mid = <font color={color}>{text_mid}</font>
      } else if (found_tag_type == 'i') {
        text_mid = <i>{text_mid}</i>
      } else if (found_tag_type == 'b') {
        text_mid = <b>{text_mid}</b>
      }

      return [text_before, text_mid, text_end]

    } else {
      return text
    }

  }

  const openNewCard = (newID, addToCardsList=true) => {
    goToTop()
    props.openNewCard(newID, addToCardsList)
  }

  const closeCards = () => {
    props.closeCards()
  }

  const SoundLayout = (props) => {
    if (props.card.type == 'MINION' || props.card.id == 'EX1_323') {return (<MinionSounds card={props.card}/>)}
    else if (props.card.type == 'HERO') {return(<HeroSounds card={props.card}/>)}
    else {return (<></>)}
  }

  function imageHeight() {
    if (deviceType == 'mobile')
      return "65%"
    else if (isHero)
      return 345
    else if (props.battlegrounds)
      return 395
    else
      return 388
  }

  const styles = StyleSheet.create({
    image: {
      aspectRatio: 1.5,
      height: imageHeight(),
      width: '100%',
      resizeMode: 'contain'
    },
    switchSetStyle: {
      height: '100%', width:40, resizeMode: 'contain'
    }
  })

  const SetSwitcher = () => {
    const versionGroup = cardVersionGroup(cardID)
    const [switchSet, setSwitcherSet] = React.useState(versionGroup != undefined ? {
      "core": versionGroup.core == cardID,
      "wild": versionGroup.wild == cardID,
      "classic": versionGroup.classic == cardID
    } : {"core": false, "wild": false, "classic": false})

    return (
      <>
      { (versionGroup != undefined) ?
        <View style={{justifyContent: 'center', height: 40, flexDirection: 'row', position: 'absolute', top: 0, right: 0, left: 0, zIndex : 1}}>
          {versionGroup.core != undefined ? <TouchableOpacity onPress={() => {
            if(cardID != versionGroup.core) {
              setSwitcherSet({"core": true, "wild": false, "classic": false})
              openNewCard(versionGroup.core, false)
            }
          }}><Image source={require(switchSet.core ? './assets/img/set_icons/GryphonIconSelected.png' : './assets/img/set_icons/GryphonIcon.png')} style={styles.switchSetStyle}/></TouchableOpacity> : <></>}
          {versionGroup.wild != undefined ? <TouchableOpacity onPress={() => {
            if(cardID != versionGroup.wild) {
              setSwitcherSet({"core": false, "wild": true, "classic": false})
              openNewCard(versionGroup.wild, false)
            }
          }}><Image source={require(switchSet.wild ? './assets/img/set_icons/Set1_IconSelected.png' : './assets/img/set_icons/Set1_Icon.png')} style={styles.switchSetStyle}/></TouchableOpacity> : <></>}
          {versionGroup.classic ? <TouchableOpacity onPress={() => {
            if(cardID != versionGroup.classic) {
              setSwitcherSet({"core": false, "wild": false, "classic": true})
              openNewCard(versionGroup.classic, false)
            }
          }}><Image source={require(switchSet.classic ? './assets/img/set_icons/ClassicIconSelected.png' : './assets/img/set_icons/ClassicIcon.png')} style={styles.switchSetStyle}/></TouchableOpacity> : <></>}
        </View>
        : <></>
      }
    </>
    )
  }


  return (
    <>
      {props.previousCardExists ?
        <TouchableOpacity style={{position: 'absolute', top: 0, left: 0, zIndex : 2}} onPress={() => {
            goToTop()
            props.returnToPreviousCard()}}
            >
          <Ionicons name="md-arrow-round-back" size={36} color="#bdbdbd" />
        </TouchableOpacity>
        : <></>
      }
      <TouchableOpacity style={{position: 'absolute', top: 0, right: 0, zIndex : 2}} onPress={() => {
          props.closeCards()}}
          >
        <Ionicons name="md-close" size={36} color="#bdbdbd" />
      </TouchableOpacity>
      <SetSwitcher/>
      <View style={{ flex: 1, padding: 8, alignItems: 'center'}}>
      <Image source={{uri: imgSrc}} style={styles.image}/>

        <ScrollView style={{width: "100%"}} ref={scrollViewRef}>
          <Text style={{padding: 16}}>{formatText(findFlavor())}</Text>
          <SoundDivider/>
          <SoundLayout card={props.card}/>
          <SpecialsFlatList card={props.card} openNewCard={openNewCard} closeCard={closeCards}/>
          <Specials cardID={cardID}/>
          <TokensFlatList cardID={cardID} cardClass = {props.card.cardClass} openNewCard={openNewCard} closeCard={closeCards} battlegrounds={props.battlegrounds}/>
        </ScrollView>
      </View>
    </>
  )
}



export default Card
